import React, { useState } from 'react';
import { CoursesTab } from './CoursesTab';
import { AttendanceTab } from './AttendanceTab';
import { GradesTab } from './GradesTab';

type TabType = 'courses' | 'attendance' | 'grades';

export function AcademicsPage() {
  const [activeTab, setActiveTab] = useState<TabType>('courses');

  const tabs: { id: TabType; label: string; labelHe: string }[] = [
    { id: 'courses', label: 'Courses', labelHe: 'קורסים' },
    { id: 'attendance', label: 'Attendance', labelHe: 'נוכחות' },
    { id: 'grades', label: 'Grades', labelHe: 'ציונים' },
  ];

  return (
    <div className="min-h-full">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Academics</h1>
        <p className="text-sm text-gray-500">Administrator Platform</p>
      </div>

      {/* Tabs */}
      <div className="mb-6 border-b border-gray-200">
        <nav className="flex gap-8" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`pb-4 text-sm font-medium transition-colors relative ${
                activeTab === tab.id
                  ? 'text-teal-600 border-b-2 border-teal-600'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'courses' && <CoursesTab />}
        {activeTab === 'attendance' && <AttendanceTab />}
        {activeTab === 'grades' && <GradesTab />}
      </div>
    </div>
  );
}

export default AcademicsPage;
